import React, { useMemo } from 'react';

import { ALL_SELECT_OPTION, getReservationTypeOptions } from '../../utils/selectOptions';
import { AdaptiveSelect } from '../AdaptiveSelect/AdaptiveSelect';
import { useReservationTypes } from '../../hooks/AppData/useReservationTypes';

interface Props {
  onChange: (reservationTypeName: string | undefined) => void;
  value?: string;
  id: string;
  className?: string;
  placeholder: string;
  selectAllOption: boolean;
}

// One reservation type by name (types with the same name in several branches are one option); the "all" option gives undefined.
export const ReservationTypeSelect = ({ onChange, id, value, className, placeholder, selectAllOption }: Props) => {
  const { uniqueReservationTypes, reservationTypesLoading } = useReservationTypes();

  const options = useMemo(
    () => getReservationTypeOptions(uniqueReservationTypes, selectAllOption),
    [uniqueReservationTypes, selectAllOption],
  );

  const handleChange = (newValue: string) => {
    onChange(newValue === ALL_SELECT_OPTION ? undefined : newValue);
  };

  const reservationTypeTemplate = (option: { label: string }) => {
    return <span>{option.label}</span>;
  };

  return (
    <AdaptiveSelect
      id={id}
      value={value}
      onChange={handleChange}
      options={options}
      itemTemplate={reservationTypeTemplate}
      placeholder={placeholder}
      modalTitle='Seleccionar tipo de reserva'
      searchPlaceholder='Buscar reservas'
      className={className}
      loading={reservationTypesLoading}
      emptyMessage='No hay tipos de reserva'
      emptyFilterMessage='No se han encontrado tipos de reserva'
    />
  );
};
